module.exports = __webpack_public_path__ + "img/code-call-center.904506ac.png";